import { styled, type CSS } from 'styles'
import { Box } from './Box'

export const StyledCard = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  bg: '$cardGradient',
  boxShadow: '0px 4px 24px -1px $black33',
  borderRadius: '$base',
})

export const Card = StyledCard

type CardBorderProps = {
  children: React.ReactNode
  innerCss?: CSS
  innerClassName?: string
  outerClassName?: string
  outerCss?: CSS
  bgImage?: string
  bgColor?: string
  borderWidth?: CSS['padding']
  borderRadius?: CSS['borderRadius']
}

export const CardBorder = (props: CardBorderProps) => {
  const { children, borderWidth = 2, borderRadius = '$base', innerCss, outerCss, innerClassName, outerClassName, bgImage = '$borderGradient', bgColor = '$background' } = props

  return (
    <Box
      className={outerClassName}
      css={{
        bgImage,
        borderRadius,
        padding: borderWidth,
        ...outerCss,
      }}
    >
      <Box
        className={innerClassName}
        css={{
          bgColor,
          size: '100%',
          borderRadius,
          ...innerCss,
        }}
      >
        {children}
      </Box>
    </Box>
  )
}
